module.exports = __webpack_public_path__ + "img/shape-6.7be30f8d.png";